import React, { useEffect, useState } from 'react';
import { ParamsNotFoundError } from '../../../helpers/definedErrors';
import { Text, Card, CloseButton, Button } from '@smarterservices/smarter-ui';

import { removeIframe, sendMessageToExtension } from '../../../helpers/helpers';

const MediaPermissions = () => {
  const [iframeId, setIframeId] = useState(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    const mediaPermissionParams = new Proxy(new URLSearchParams(url.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (!mediaPermissionParams.iframeId) {
      throw new ParamsNotFoundError();
    }

    setIframeId(mediaPermissionParams.iframeId);
  }, []);

  async function closeMediaPermissions() {
    const response = await removeIframe(iframeId);

    if (!response) {
      console.log(
        'Extension was removed and popup remains. Reload page to remove.'
      );
    }
  }

  async function accept() {
    const response = await sendMessageToExtension({
      message: 'sp_background__raiseSetMediaPermissions',
      iframeId: 'spRaiseSetMediaPermissions',
      sessionUiFrameId: iframeId,
    });

    if (!response) {
      console.log('No response from raiseSetMediaPermissions function.');
    }
  }

  return (
    <>
      {iframeId && (
        <Card
          background="secondary"
          borderColor="brand"
          borderWidth="large"
          borderRadius="x-small"
        >
          <Card.Header background="brand">
            <Card.Title>Media Permissions</Card.Title>
            <Card.Actions>
              <CloseButton
                color="primary-inverse"
                screenReaderLabel="Close"
                onClick={closeMediaPermissions}
              />
            </Card.Actions>
          </Card.Header>
          <Card.Body padding="0" height="100%">
            <div
              style={{
                position: 'relative',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              {/* Scrollable text area */}
              <div
                style={{
                  width: '100%',
                  maxHeight: 'calc(100% - 100px)',
                  padding: '48px 32px',
                  overflow: 'auto',
                  textAlign: 'center',
                }}
              >
                <Text size="medium" align="center">
                  {
                    "Our extension needs permission to use your media devices, click 'Allow' and try again."
                  }
                </Text>
              </div>

              {/* Fixed button container */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  height: '100px',
                  padding: '0px 32px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'start',
                }}
              >
                <Button color="primary" onClick={accept}>
                  Allow
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default MediaPermissions;
